// src/app/features/peelhalton/oakville/oakville-routing.module.ts
import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {PeelHaltonDashboardComponent} from '../shared/components/dashboard/peelhalton-dashboard.component';
import {PeelHaltonListingDetailsFullComponent} from '../shared/components/listing-details/peelhalton-listing-details-full.component';

const routes: Routes = [
  {path: '', component: PeelHaltonDashboardComponent},
  {path: 'fulldetails/:addressStr/:cityStr/:MLSNum', component: PeelHaltonListingDetailsFullComponent},
  {path: 'fulldetails/:MLSNum', component: PeelHaltonListingDetailsFullComponent},
  {path: ':addressStr/:cityStr/:MLSNum', component: PeelHaltonListingDetailsFullComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BurlingtonRoutingModule {
}
